import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import { IBrand } from "@/types/page";
import adminAxios from "@/lib/axios";

export async function createBrand(payload: Partial<IBrand>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.BRAND.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateBrand(id: number, payload: Partial<IBrand>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.BRAND.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
